import {Injectable, EventEmitter} from '@angular/core';

@Injectable()
export class EventEmiterService {
  emitter = new EventEmitter();

  public readonly events = {
    onTankProfileSettingsClicked: "onTankProfileSettingsClicked",
    onCollapseSidebar: "onCollapseSidebar"
  }

  constructor() { }

  sendMessage(data: any) {
    this.emitter.emit(data);
  }
}
